export const DEFAULT_FONT = 'openSans'
